import formatContent from './formatContent'
import setAlertContent from './setAlertContent'

export default {
  formatContent,
  setAlertContent,
}
